export default {
  // Navigation
  home: 'Accueil',
  solutions: 'Solutions',
  sectors: 'Secteurs',
  ecosystem: 'Écosystème',
  about: 'À Propos',
  recruitment: 'Recrutement',
  contact: 'Contact',

  // Hero Section
  heroHeadline: 'Transformez votre entreprise avec la bonne technologie',
  heroSubheadline: "Alpha Solutions intègre, déploie et accompagne les systèmes ERP & logiciels métiers pour les entreprises africaines — de l'audit à la mise en production, jusqu'au support.",
  requestConsultation: 'Demander une Consultation',
  discoverSolutions: 'Voir nos solutions',

  // What We Do Section
  whatWeDoTitle: "Nos Domaines d'Expertise",
  whatWeDoSubtitle: 'Des solutions technologiques complètes pour digitaliser, automatiser et contrôler chaque aspect de votre activité.',
  businessSoftware: "Logiciels d'Entreprise",
  businessSoftwareDesc: "ERP, CRM, comptabilité, RH — les systèmes de gestion qui centralisent et pilotent toute votre activité.",
  industrySoftware: 'Logiciels Sectoriels',
  industrySoftwareDesc: "Restauration, hôtellerie, commerce, éducation, santé — des solutions conçues pour votre métier.",
  automationDigitalization: 'Automatisation & Digitalisation',
  automationDigitalizationDesc: 'Automatisez vos processus, connectez vos systèmes et pilotez votre activité avec les données.',
  smartInfrastructure: 'Infrastructure Intelligente & Sécurité',
  smartInfrastructureDesc: "Vidéosurveillance, contrôle d'accès, biométrie et réseaux — protégez et connectez votre entreprise.",

  // Why Choose Us Section
  whyChooseTitle: 'Ce Qui Nous Distingue',
  whyChooseSubtitle: 'Pas seulement un fournisseur — un véritable partenaire qui comprend vos enjeux et vous guide vers les bonnes décisions technologiques.',
  solutionExpertise: 'Expertise en Solutions',
  solutionExpertiseDesc: "Notre équipe maîtrise un large éventail de technologies et sait identifier la solution la plus adaptée à chaque situation.",
  technologySelection: 'Sélection Technologique',
  technologySelectionDesc: 'Nous analysons le marché pour vous recommander les outils les plus performants et les mieux adaptés à votre secteur.',
  reliableImplementation: 'Implémentation Fiable',
  reliableImplementationDesc: 'Déploiement rigoureux, tests complets et mise en service accompagnée pour garantir un démarrage sans accroc.',
  trainingSupport: 'Formation & Support',
  trainingSupportDesc: "Formation complète de vos équipes et support 24/7 pour que vous tirez le maximum de votre investissement.",

  // Technology Ecosystem Section
  techEcosystemTitle: 'Des Technologies Mondiales, Une Expertise Locale',
  techEcosystemSubtitle: 'Nous collaborons avec des éditeurs de logiciels et des fournisseurs de confiance pour vous apporter des solutions éprouvées, adaptées au marché africain.',
  techEcosystemDesc: "Alpha Solutions s'appuie sur un réseau solide de partenaires technologiques mondiaux pour vous offrir des systèmes fiables, modernes et évolutifs — sélectionnés, intégrés et supportés localement.",
  techEcosystemFeature1: 'Accès aux meilleures technologies disponibles sur le marché mondial',
  techEcosystemFeature2: "Systèmes éprouvés par des milliers d'entreprises à travers le monde",
  techEcosystemFeature3: 'Solutions adaptées aux réalités et contraintes du marché africain',
  techEcosystemFeature4: 'Support local en français avec expertise internationale',

  // Industries Served Section
  industriesServedTitle: 'Nous Connaissons Votre Secteur',
  industriesServedSubtitle: 'Des solutions conçues pour les réalités opérationnelles de chaque industrie, de la restauration à la finance.',
  sectorNotListed: "Votre secteur n'est pas dans la liste ?",
  discussProject: 'Discuter de votre projet',

  // Sector names
  hotellerie: 'Hôtellerie',
  restauration: 'Restauration',
  beaute: 'Beauté & Bien-être',
  evenementiel: 'Événementiel',
  immobilier: 'Immobilier',
  commerce: 'Commerce & Retail',
  production: 'Production',
  education: 'Éducation',
  sante: 'Santé & Pharmacie',
  transport: 'Transport & Logistique',
  finance: 'Finance & Microfinance',
  administration: 'Administration',
  prestataireService: 'Prestataires Service',
  btpConstruction: 'BTP & Construction',
  rhPlacement: 'RH & Placement',
  cabinetsConseil: 'Cabinets & Conseil',
  videoSurveillance: 'Vidéosurveillance',
  atelierGarage: 'Atelier & Garage',
  bulkSms: 'Bulk SMS & WhatsApp',

  // Call To Action Section
  ctaTitle: 'Parlons de Votre Projet',
  ctaSubtitle: 'Nos experts sont disponibles pour analyser vos besoins et vous recommander les meilleures solutions — sans engagement.',
  ctaExpertTitle: 'Parler à un Expert',
  ctaExpertDesc: 'Obtenez des réponses rapides à vos questions de nos spécialistes technologiques.',
  ctaNeedsTitle: 'Partagez Vos Besoins',
  ctaNeedsDesc: 'Décrivez vos défis opérationnels et nous vous proposerons les solutions adaptées.',
  ctaDemoTitle: 'Demander une Démo',
  ctaDemoDesc: 'Voyez nos solutions en action avec une démonstration personnalisée pour votre secteur.',
  startConversation: 'Démarrer la Conversation',
  callUs: 'Nous Appeler',
  ctaAvailability: 'Disponible du Lundi au Samedi, 8h00 - 18h00',
  contactExpert: 'Contacter un Expert',
  shareNeeds: 'Partager Mes Besoins',

  // Solutions Menu
  erp: 'ERP',
  crm: 'CRM',
  accounting: 'Comptabilité',
  hr: 'Ressources Humaines',

  // Footer
  footerDescription: "Votre partenaire de confiance pour la transformation digitale. Nous aidons les entreprises africaines à adopter les meilleures technologies disponibles sur le marché pour digitaliser leurs opérations, automatiser leurs processus et contrôler leurs activités.",
  ourServices: 'Nos Services',
  usefulLinks: 'Liens Utiles',
  followUs: 'Suivez-nous',
  allRightsReserved: 'Tous droits réservés',
  erpSystems: 'Systèmes ERP',
  crmSystems: 'Systèmes CRM',
  accountingSoftware: 'Logiciels Comptables',
  hrSoftware: 'Logiciels RH',
  industrySpecific: 'Solutions Sectorielles',
  technologyIntegration: 'Intégration Technologique',
  trustedAdvisor: 'Conseiller Technologique de Confiance',
  digitalPartner: 'Partenaire de Transformation Digitale',
  solutionIntegrator: 'Intégrateur de Solutions',
  expertSupport: 'Support Expert',

  // Call to Actions
  talkToExpert: 'Parler à un Expert',
  requestDemo: 'Demander une Démo',
  getStarted: 'Commencer',
  learnMore: 'En Savoir Plus',
  whatsappButton: 'Contactez-nous sur WhatsApp',

  // Contact Page
  contactPageTitle: 'Discutons de Votre Projet',
  contactPageSubtitle: 'Notre équipe répond en moins de 2 heures. Choisissez la formule qui vous convient.',
  contactConsultationTitle: 'Demander une Consultation',
  contactConsultationDesc: "Discutez avec nos experts pour analyser vos besoins et identifier les meilleures solutions technologiques pour votre entreprise.",
  contactDemoTitle: 'Demander une Démo',
  contactDemoDesc: "Découvrez nos solutions en action avec une démonstration personnalisée adaptée à votre secteur d'activité.",
  contactExpertTitle: 'Parler à un Expert',
  contactExpertDesc: 'Obtenez des réponses rapides à vos questions techniques ou commerciales de la part de nos spécialistes.',
  formFullName: 'Nom complet',
  formCompany: 'Entreprise',
  formSector: "Secteur d'activité",
  formPhone: 'Téléphone/WhatsApp',
  formEmail: 'Email',
  formMessage: 'Votre message',
  formRequestType: 'Type de demande',
  formSelectSector: 'Sélectionnez votre secteur',
  formSelectRequest: 'Sélectionnez le type de demande',
  requestConsultationType: 'Consultation stratégique',
  requestDemoType: 'Démonstration de solution',
  requestQuoteType: 'Demande de devis',
  requestSupportType: 'Support technique',
  requestPartnershipType: 'Partenariat',
  requestOtherType: 'Autre',
  submitConsultation: 'Demander une Consultation',
  submitDemo: 'Demander une Démo',
  submitContact: 'Envoyer le Message',
  sending: 'Envoi en cours...',
  formSuccessTitle: 'Message envoyé avec succès !',
  formSuccessMessage: "Nous avons bien reçu votre demande. Notre équipe vous contactera dans les 2 heures ouvrables.",
  formErrorTitle: "Erreur d'envoi",
  formErrorMessage: "Une erreur s'est produite. Veuillez réessayer ou nous contacter directement par téléphone.",
  contactInfoTitle: 'Informations de Contact',
  contactInfoSubtitle: 'Plusieurs façons de nous joindre',
  whatsappLabel: 'WhatsApp',
  phoneLabel: 'Téléphone',
  locationLabel: 'Localisation',
  emailLabel: 'Email',
  locationAddress: 'Douala, Akwa - Cameroun',
  quickResponseTitle: 'Réponse Rapide Garantie',
  quickResponseMessage: "Nous nous engageons à vous répondre dans les 2 heures ouvrables",
  businessHoursTitle: "Horaires d'Ouverture",
  businessHoursWeekdays: 'Lundi - Vendredi : 8h00 - 18h00',
  businessHoursSaturday: 'Samedi : 9h00 - 14h00',
  businessHoursSunday: 'Dimanche : Fermé',
  whyContactTitle: 'Pourquoi Nous Contacter ?',
  whyContact1: 'Expertise reconnue depuis 8 ans',
  whyContact2: 'Solutions adaptées à votre secteur',
  whyContact3: 'Support local en français',
  whyContact4: 'Accompagnement personnalisé',

  // Ecosystem Page
  ecosystemHeroTitle: "Alpha Solutions : Le Pont entre le Monde Technologique et l'Afrique",
  ecosystemHeroSubtitle: "Alpha Solutions collabore avec des fournisseurs technologiques de confiance, des éditeurs de logiciels et des partenaires mondiaux pour offrir les meilleures solutions adaptées aux entreprises africaines.",
  ecosystemHeroCTA1: 'Découvrir Nos Partenaires',
  ecosystemHeroCTA2: 'Devenir Partenaire',
  ecosystemPartnersTitle: 'Un Réseau de Partenaires Technologiques de Confiance',
  ecosystemPartnersSubtitle: "Nous travaillons avec un réseau mondial de fournisseurs de technologies et d'éditeurs de logiciels pour offrir des solutions fiables et éprouvées.",
  ecosystemPartner1Title: 'Fournisseurs Technologiques Globaux',
  ecosystemPartner1Desc: 'Nous collaborons avec des leaders mondiaux de la technologie pour accéder aux systèmes les plus avancés et les plus fiables du marché.',
  ecosystemPartner2Title: 'Éditeurs de Logiciels',
  ecosystemPartner2Desc: 'Partenariats avec des éditeurs de logiciels spécialisés dans les solutions ERP, CRM, comptabilité, RH et gestion sectorielle.',
  ecosystemPartner3Title: 'Fournisseurs de Solutions',
  ecosystemPartner3Desc: 'Réseau de partenaires offrant des solutions complémentaires en automatisation, sécurité, infrastructure et services cloud.',
  ecosystemRoleTitle: 'Notre Mission dans Cet Écosystème',
  ecosystemRoleSubtitle: "Alpha Solutions agit comme pont entre les technologies mondiales et les besoins des entreprises africaines.",
  ecosystemRole1Title: 'Intégrateur de Solutions',
  ecosystemRole1Desc: "Nous sélectionnons, adaptons et intégrons les meilleures technologies pour répondre aux besoins spécifiques de chaque entreprise.",
  ecosystemRole1Feature1: 'Analyse approfondie des besoins métier',
  ecosystemRole1Feature2: 'Sélection des solutions les plus adaptées',
  ecosystemRole1Feature3: 'Intégration technique et configuration',
  ecosystemRole1Feature4: 'Tests et validation avant déploiement',
  ecosystemRole2Title: 'Partenaire de Déploiement',
  ecosystemRole2Desc: 'Nous assurons le déploiement complet des solutions technologiques avec accompagnement, formation et support continu.',
  ecosystemRole2Feature1: 'Planification et gestion de projet',
  ecosystemRole2Feature2: 'Installation et configuration sur site',
  ecosystemRole2Feature3: 'Formation complète des utilisateurs',
  ecosystemRole2Feature4: 'Support technique et maintenance',
  ecosystemRole3Title: 'Conseiller Technologique',
  ecosystemRole3Desc: 'Nous guidons les entreprises dans leurs choix technologiques en recommandant les solutions les plus pertinentes pour leur contexte.',
  ecosystemRole3Feature1: 'Audit technologique et diagnostic',
  ecosystemRole3Feature2: 'Recommandations stratégiques',
  ecosystemRole3Feature3: 'Veille technologique et innovation',
  ecosystemRole3Feature4: 'Accompagnement dans la transformation digitale',
  ecosystemBenefitsTitle: 'Pourquoi Travailler avec Notre Écosystème',
  ecosystemBenefitsSubtitle: 'Les avantages de notre approche collaborative et notre réseau de partenaires technologiques.',
  ecosystemBenefit1Title: 'Solutions Éprouvées',
  ecosystemBenefit1Desc: "Accès à des technologies testées et validées par des milliers d'entreprises dans le monde.",
  ecosystemBenefit2Title: 'Expertise Locale',
  ecosystemBenefit2Desc: 'Adaptation des solutions globales aux réalités et contraintes du marché africain.',
  ecosystemBenefit3Title: 'Support Continu',
  ecosystemBenefit3Desc: 'Assistance technique locale en français et accompagnement sur le long terme.',
  ecosystemBenefit4Title: 'Évolution Garantie',
  ecosystemBenefit4Desc: 'Mises à jour régulières et accès aux nouvelles fonctionnalités des solutions.',
  ecosystemValuesTitle: 'Nos Valeurs de Partenariat',
  ecosystemValuesSubtitle: 'Les principes qui guident nos collaborations avec les fournisseurs de technologies et nos clients.',
  ecosystemValue1Title: 'Collaboration Transparente',
  ecosystemValue1Desc: 'Communication ouverte et honnête avec nos partenaires technologiques et nos clients pour garantir le succès de chaque projet.',
  ecosystemValue2Title: 'Excellence Technique',
  ecosystemValue2Desc: "Engagement à maintenir les plus hauts standards de qualité dans la sélection, l'intégration et le déploiement des solutions.",
  ecosystemValue3Title: 'Confiance Mutuelle',
  ecosystemValue3Desc: 'Relations durables basées sur la confiance, le respect des engagements et la création de valeur partagée.',
  ecosystemValue4Title: 'Innovation Continue',
  ecosystemValue4Desc: 'Recherche constante de nouvelles technologies et solutions pour répondre aux besoins évolutifs des entreprises.',
  ecosystemCTATitle: 'Rejoignez Notre Réseau de Partenaires',
  ecosystemCTASubtitle: "Vous êtes un éditeur de logiciels ou un fournisseur de technologies cherchant un partenaire local fiable en Afrique ? Discutons de la manière dont nous pouvons collaborer.",
  ecosystemCTAButton1: 'Nous Contacter',
  ecosystemCTAButton2: 'WhatsApp',

  // About Page
  aboutHeroTitle: "Nés en Afrique, Pensés Pour l'Afrique",
  aboutHeroSubtitle: "Votre partenaire de confiance pour naviguer dans le monde complexe des technologies d'entreprise et sélectionner les meilleures solutions pour votre croissance.",
  aboutWhoTitle: 'Qui Sommes-Nous ?',
  aboutWhoP1: "Alpha Solutions est bien plus qu'un simple fournisseur de logiciels. Nous sommes votre conseiller technologique de confiance et votre partenaire d'intégration qui vous aide à naviguer dans le monde complexe des technologies d'entreprise.",
  aboutWhoP2: 'Depuis 2018, nous collaborons avec des fournisseurs de solutions de confiance et des éditeurs de logiciels reconnus pour sélectionner, adapter et déployer les systèmes les plus performants pour les entreprises africaines.',
  aboutWhoP3: "Notre expertise réside dans notre capacité à comprendre vos besoins métier, à recommander les bonnes technologies, et à assurer leur intégration réussie dans votre environnement opérationnel.",
  aboutMethodTitle: 'Une Méthode Simple, Des Résultats Concrets',
  aboutMethodSubtitle: 'Comment nous aidons les entreprises à faire les bons choix technologiques',
  aboutStep1Title: '1. Comprendre',
  aboutStep1Desc: "Nous analysons en profondeur vos processus métier, vos défis opérationnels et vos objectifs de croissance pour identifier vos besoins réels.",
  aboutStep2Title: '2. Recommander',
  aboutStep2Desc: "Grâce à notre connaissance approfondie de l'écosystème technologique, nous sélectionnons les solutions les plus adaptées à votre contexte africain.",
  aboutStep3Title: '3. Intégrer',
  aboutStep3Desc: 'Nous déployons, configurons et intégrons les systèmes choisis avec un accompagnement complet : formation, support et maintenance continue.',
  aboutDiffTitle: 'Ce Qui Nous Distingue',
  aboutDiff1Title: 'Accès aux Meilleures Technologies',
  aboutDiff1Desc: 'Nous travaillons avec des fournisseurs de solutions reconnus mondialement pour vous offrir des systèmes éprouvés et fiables, adaptés au marché africain.',
  aboutDiff2Title: 'Expertise Locale Approfondie',
  aboutDiff2Desc: "8 ans d'expérience terrain nous permettent d'adapter les technologies internationales aux réalités et contraintes spécifiques de l'environnement business africain.",
  aboutDiff3Title: 'Conseil Indépendant et Objectif',
  aboutDiff3Desc: "Notre priorité est de recommander la solution la plus adaptée à vos besoins, pas de vendre un produit spécifique. Votre succès est notre succès.",
  aboutDiff4Title: 'Accompagnement de Bout en Bout',
  aboutDiff4Desc: "De la sélection à l'intégration, en passant par la formation et le support 24/7, nous restons à vos côtés à chaque étape de votre transformation digitale.",
  aboutVisionTitle: 'Notre Vision',
  aboutVisionP1: "Être le partenaire technologique de référence en Afrique Centrale, en aidant les entreprises à naviguer dans le monde complexe des technologies d'entreprise et à sélectionner les solutions qui accélèrent vraiment leur croissance.",
  aboutVisionP2: "Nous croyons fermement que chaque entreprise africaine mérite un accès aux meilleures technologies disponibles sur le marché mondial, adaptées à son contexte local et accompagnées d'un support d'excellence.",
  aboutMissionTitle: 'Notre Mission',
  aboutMissionP1: "Simplifier la transformation digitale des entreprises africaines en leur offrant un accompagnement expert dans la sélection, l'intégration et l'adoption des technologies qui répondent vraiment à leurs besoins.",
  aboutMission1: 'Guider les entreprises dans leurs choix technologiques complexes',
  aboutMission2: 'Collaborer avec des fournisseurs de solutions de confiance',
  aboutMission3: "Adapter les technologies mondiales à l'environnement business africain",
  aboutMission4: "Offrir un accompagnement personnalisé et un support d'exception 24/7",
  aboutHistoryTitle: "8 Ans d'Innovation au Service de l'Afrique",
  aboutHistorySubtitle: "8 ans d'innovation continue au service des entreprises africaines",
  aboutHistory1Title: '2018 - Les Débuts',
  aboutHistory1Desc: "Co-fondation d'Alpha Solutions SARL à Douala par Kevin Mbadjoun et Patrick Boujeka avec une vision claire : aider les entreprises camerounaises à accéder aux meilleures technologies de gestion.",
  aboutHistory2Title: '2020-2022 - Expansion',
  aboutHistory2Desc: "Développement de notre réseau de partenaires technologiques et expansion de notre expertise multi-sectorielle : hôtellerie, beauté, commerce, événementiel, éducation, santé.",
  aboutHistory3Title: '2023-2025 - Leadership',
  aboutHistory3Desc: "750+ entreprises clientes satisfaites, leader reconnu de l'intégration de solutions technologiques au Cameroun avec expansion vers l'Afrique Centrale.",
  aboutValuesTitle: 'Ce en Quoi Nous Croyons',
  aboutValuesSubtitle: 'Les principes qui guident notre action quotidienne au service de nos clients',
  aboutValue1: 'Confiance',
  aboutValue1Desc: "Nous bâtissons des relations durables basées sur la transparence et l'intégrité",
  aboutValue2: 'Proximité Client',
  aboutValue2Desc: 'Support 24/7, formation complète, accompagnement personnalisé à chaque étape',
  aboutValue3: 'Expertise',
  aboutValue3Desc: 'Connaissance approfondie des technologies et du marché africain',
  aboutValue4: 'Excellence',
  aboutValue4Desc: "Nous visons l'excellence dans chaque solution livrée, chaque support apporté",
  aboutTeamTitle: 'Notre Équipe',
  aboutTeamSubtitle: 'Une équipe solide et expérimentée sur laquelle votre entreprise peut compter',
  aboutCofoundersTitle: 'Co-Fondateurs',
  aboutKevinRole: 'Co-Fondateur & Directeur Général',
  aboutKevinDesc: "Visionnaire de l'entreprise, Kevin pilote la stratégie et le développement d'Alpha Solutions avec plus de 10 ans d'expérience en solutions d'entreprise.",
  aboutPatrickRole: 'Co-Fondateur',
  aboutPatrickDesc: "Co-fondateur d'Alpha Solutions en 2018 aux côtés de Kevin Mbadjoun, Patrick apporte son expertise technique et sa vision stratégique au développement de l'entreprise.",
  aboutDeptTitle: 'Nos Départements Opérationnels',
  aboutDept1: 'Opérations & Solutions',
  aboutDept1Desc: "Experts en intégration de systèmes, configuration et assistance technique. Support client 24/7 et déploiement de solutions.",
  aboutDept2: 'Conseil & Commercialisation',
  aboutDept2Desc: 'Conseillers technologiques experts pour guider nos 750+ entreprises clientes dans leurs choix de solutions.',
  aboutDept3: 'Communication & Marketing',
  aboutDept3Desc: 'Professionnels de la communication et du marketing digital. Stratégies de promotion des solutions technologiques.',
  aboutDept4: 'Veille & Innovation',
  aboutDept4Desc: "Constamment à l'écoute des demandes clients et à la recherche de nouvelles solutions pour mieux servir notre clientèle.",
  aboutEnvTitle: 'Un Environnement Solide pour Votre Réussite',
  aboutEnvDesc: 'Notre équipe multidisciplinaire constitue un environnement solide et fiable sur lequel votre entreprise peut compter pour sa transformation digitale.',
  aboutStatsTitle: 'Alpha Solutions en Chiffres',
  aboutStatsSubtitle: 'Des résultats qui parlent de notre expertise et de la confiance de nos clients',
  aboutStat1: 'Entreprises Clientes Satisfaites',
  aboutStat2: "Années d'Expérience",
  aboutStat3: 'Prospects Qualifiés/An',
  aboutStat4: 'Support Client',
  aboutWhyTitle: 'Pourquoi 750+ Entreprises Nous Ont Choisi ?',
  aboutWhySubtitle: 'Nos clients satisfaits témoignent de notre différence',
  aboutWhy1Title: 'Expertise Sectorielle Reconnue',
  aboutWhy1Desc: "8 ans d'expérience dans chaque secteur avec des solutions éprouvées par nos 750+ clients satisfaits.",
  aboutWhy2Title: "Service Client d'Exception",
  aboutWhy2Desc: "Formation complète de vos équipes, support 24/7, maintenance proactive. Nous restons à vos côtés après l'installation.",
  aboutWhy3Title: 'Solutions Adaptées à Vos Besoins',
  aboutWhy3Desc: 'Chaque solution est sélectionnée et adaptée à vos processus métier spécifiques. Nous recommandons ce qui fonctionne vraiment.',
  aboutWhy4Title: 'Vision Africaine, Standards Internationaux',
  aboutWhy4Desc: 'Basés à Douala, nous comprenons le marché africain tout en vous donnant accès aux meilleures technologies mondiales.',
  aboutCTATitle: 'Rejoignez nos 750+ Entreprises Clientes Satisfaites',
  aboutCTASubtitle: 'Découvrez comment nous pouvons vous aider à naviguer dans le monde des technologies et à sélectionner les solutions qui accélèrent votre croissance',
  aboutCTAContact: 'Nous Contacter',
  aboutCTASolutions: 'Découvrir nos Solutions',

  // Pricing
  pricingBadge: 'Nos Packs',
  pricingTitle: 'Des packs adaptés à votre taille',
  pricingSubtitle: "Quel que soit votre secteur d'activité, nous avons une formule qui correspond à vos besoins et à votre budget.",
  pricingTariff: 'Tarif',
  pricingOnQuote: 'Sur devis personnalisé',
  pricingAdapted: 'Adapté à votre secteur & taille',
  pricingCTA: 'Demander un devis',
  pricingNote: 'Tous les packs incluent une maintenance annuelle + SAV. Chaque secteur dispose de sa propre grille tarifaire — contactez-nous pour un devis sur mesure.',
  pricingMostPopular: 'Le plus populaire',
  pricingPack1Name: 'Essentiel',
  pricingPack1Tagline: 'Pour démarrer efficacement',
  pricingPack1Target: 'Petites structures & indépendants',
  pricingPack2Name: 'Croissance',
  pricingPack2Tagline: 'Pour les entreprises en expansion',
  pricingPack2Target: 'PME & structures en développement',
  pricingPack3Name: 'Expert',
  pricingPack3Tagline: 'Pour les grandes organisations',
  pricingPack3Target: 'Grandes entreprises & multi-sites',

  // Hero hardcoded
  heroBadge: 'Intégrateur ERP & Partenaire Digital',
  heroTrustLabel: 'Ils nous font confiance',
  heroTrustMore: '+ 994 autres',
  heroBookRDV: 'Prendre rendez-vous',

  // References
  refTitle: '1 000+ entreprises accompagnées depuis 2018',
  refSubtitle: "Des entreprises de tous secteurs nous font confiance pour leur transformation digitale à travers l'Afrique centrale.",
  refTestimonialsTitle: 'Témoignages clients par secteur',
  refClientsTitle: 'Nos entreprises partenaires',
  refPartnersTitle: 'Nos partenaires technologiques',
  refTrustBadge: 'Ils nous font confiance',
  refPartnerCTA: 'Vous développez une solution ?',
  refPartnerCTASub: 'Proposez-la à nos 1 000+ clients →',

  // Solutions Grid
  solutionsGridTitle: 'Tout ce dont votre entreprise a besoin, sous un seul toit',
  solutionsGridSubtitle: "Des solutions intégrées et déployées par nos experts — de l'audit initial jusqu'au support continu.",
  solutionsGridCTA: 'Demander une démo gratuite',

  // Sector pages common
  sectorDemoBtn: 'Demander une Démo',
  sectorFreeDemo: 'Demander une Démo Gratuite',
  sectorViewSolutions: 'Voir toutes nos solutions',
  sectorWhyChoose: 'Pourquoi Choisir Nos Solutions ?',

  // Methodology section
  methodologyBadge: 'Notre méthode',
  methodologyTitle: "De l'audit au support — nous ne lâchons pas la main",
  methodologySubtitle: 'Un accompagnement structuré en 6 étapes pour garantir le succès de votre projet, de A à Z.',
  methodologyStep1Title: 'Audit & Cadrage',
  methodologyStep1Desc: "Analyse de vos processus métier, identification des besoins et définition du périmètre du projet.",
  methodologyStep2Title: 'Paramétrage',
  methodologyStep2Desc: "Configuration du logiciel selon vos spécificités : workflows, utilisateurs, droits d'accès, modules.",
  methodologyStep3Title: 'Reprise des données',
  methodologyStep3Desc: 'Migration sécurisée de vos données existantes (Excel, ancien logiciel) vers le nouveau système.',
  methodologyStep4Title: 'Formation',
  methodologyStep4Desc: 'Formation complète de vos équipes sur site, en français, adaptée à chaque profil utilisateur.',
  methodologyStep5Title: 'Phase pilote',
  methodologyStep5Desc: 'Démarrage en conditions réelles avec accompagnement renforcé pour valider chaque processus.',
  methodologyStep6Title: 'Déploiement & Support',
  methodologyStep6Desc: 'Mise en production complète + maintenance annuelle + SAV réactif en local, en français.',
  methodologyCTA: 'Démarrer mon projet',

  // StatsBar
  stat1Label: 'Entreprises accompagnées',
  stat1Sub: 'Depuis 2018',
  stat2Label: 'Clients actifs ERP',
  stat2Sub: 'Logiciels & solutions',
  stat3Label: 'Campagnes SMS exécutées',
  stat3Sub: 'Communication',
  stat4Label: 'ERP connectés via API',
  stat4Sub: 'Intégration technologique',
  stat5Label: "Secteurs d'expertise",
  stat5Sub: 'Métiers & industriels',

  // CallToAction hardcoded
  ctaBookTitle: 'Prendre rendez-vous',
  ctaBookDesc: "Réservez un créneau avec l'un de nos commerciaux pour une réunion dédiée à votre projet.",
  ctaBookBtn: 'Réserver mon créneau',
  ctaBookBtnMain: 'Prendre rendez-vous',

  // SolutionsGrid hardcoded solution titles & descriptions
  solErpTitle: "ERP & Gestion d'Entreprise",
  solErpDesc: 'Systèmes ERP métiers sectoriels, intégration complète de vos processus de gestion.',
  solPosTitle: 'POS & Commerce',
  solPosDesc: 'Caisses intelligentes, gestion de stock en temps réel, facturation automatisée.',
  solCrmTitle: 'CRM & Ventes',
  solCrmDesc: 'Relation client, pipelines de vente, devis, facturation et relances automatiques.',
  solSmsTitle: 'Bulk SMS & WhatsApp',
  solSmsDesc: 'Campagnes massives, WhatsApp Business API, OTP, alertes et marketing digital.',
  solCctvTitle: 'Vidéosurveillance & Domotique',
  solCctvDesc: "Surveillance intelligente, biométrie, contrôle d'accès et domotique d'entreprise.",
  solChatTitle: 'Chatbots & Automatisation',
  solChatDesc: 'Chatbots WhatsApp/web, intégrations API sur mesure et automatisation des flux.',
  solInfraTitle: 'Infrastructure & Réseaux',
  solInfraDesc: "Réseaux d'entreprise, serveurs, cloud, firewall et sécurité informatique.",
  solPayTitle: 'Paiements & Fintech',
  solPayDesc: 'MTN Money, Orange Money, Wave, paiements en ligne et rapprochement bancaire.',
  solWebTitle: 'Développement & Sites Web',
  solWebDesc: 'Sites web professionnels, applications iOS/Android et développement sur mesure.',

  // Solutions page
  solutionsPageBadge: 'Solutions Logicielles Professionnelles',
  solutionsPageTitle: 'Nos Solutions Logicielles',
  solutionsPageSubtitle: "Découvrez notre gamme complète de solutions technologiques adaptées à votre secteur d'activité",
  solutionsPageDemoBtn: 'Demander une Démo',
  solutionsPageFilterTitle: 'Filtrer par secteur',
  solutionsPageAllSectors: 'Tous les secteurs',
  solutionsPageNotListed: "Votre secteur n'est pas listé ?",
  solutionsPageNotListedDesc: "Nous développons des solutions sur mesure pour tous les secteurs d'activité. Contactez-nous pour discuter de vos besoins spécifiques.",
  solutionsPageCustomBtn: 'Demander une solution sur mesure',
  solutionsPageWriteBtn: 'Nous écrire',
  solutionsPageReadyTitle: 'Prêt à Transformer Votre Entreprise ?',
  solutionsPageReadyDesc: 'Rejoignez les 750+ entreprises clientes satisfaites qui nous font confiance pour leur transformation digitale',
  solutionsPageFreeDemoBtn: 'Demander une Démo Gratuite',
  solutionsPageAboutBtn: 'En savoir plus sur nous',
  howWeHelpTitle: 'Comment Alpha Solutions Vous Aide à Choisir le Bon Système',
  howWeHelpSubtitle: "Notre approche de conseil et d'intégration garantit le succès de votre transformation digitale",
  howWeHelpStep1: '1. Analyse de Vos Besoins',
  howWeHelpStep1Desc: 'Nous étudions en profondeur vos processus métier et identifions vos besoins spécifiques',
  howWeHelpStep2: '2. Recommandation Experte',
  howWeHelpStep2Desc: 'Nous vous conseillons les meilleures solutions technologiques adaptées à votre contexte',
  howWeHelpStep3: '3. Intégration & Déploiement',
  howWeHelpStep3Desc: 'Nous configurons et déployons les systèmes en respectant vos contraintes opérationnelles',
  howWeHelpStep4: '4. Formation & Support',
  howWeHelpStep4Desc: 'Nous formons vos équipes et assurons un support continu pour garantir votre succès',
  talkToExpertBtn: 'Parler à un Expert',
  solutionsSectorTitle: "Secteurs d'Activité",
  solutionsSectorSubtitle: 'Découvrez nos solutions spécialisées par secteur avec des témoignages de nos clients satisfaits',
  solutionsBySectorTitle: 'Solutions Logicielles par Secteur',
  solutionsBySectorSubtitle: 'Systèmes spécialisés adaptés aux besoins spécifiques de chaque industrie',
  solutionDetailBtn: 'Voir les détails',
  solutionContactBtn: 'Contacter un expert',
  solutionContactUs: 'Nous contacter',
  solutionFeaturedBadge: 'PRODUIT PHARE',
  solutionCompleteBadge: 'SOLUTION COMPLÈTE',
  solutionViewDetails: 'Voir les détails',
  solutionRequestDemo: 'Demander une démo',

  // ERP page
  erpPageBadge: 'SOLUTION COMPLÈTE',
  erpPageTitle: 'ERP - Solution Intégrée',
  erpPageSubtitle: 'Notre solution ERP phare qui transforme la gestion de votre entreprise avec plus de 20 modules intégrés',
  erpPageDemoBtn: 'Demander une Démo',
  erpPageTestimonialBtn: 'Voir Témoignage Client',
  erpPageTabFeatures: 'Fonctionnalités',
  erpPageTabAdvantages: 'Nos Avantages',
  erpPageTabTestimonial: 'Client Satisfait',
  erpPageFeaturesTitle: '20+ Modules Intégrés',
  erpPageFeaturesSubtitle: 'Une solution complète qui couvre tous les aspects de votre entreprise',
  erpPageCustomBadge: '100% Personnalisables selon vos besoins',
  erpPageAdvantagesTitle: 'Pourquoi Choisir Notre ERP ?',
  erpPageAdvantagesSubtitle: "8 années d'expérience au service de 750+ entreprises satisfaites",
  erpPageTestimonialTitle: 'Client Satisfait',
  erpPageTestimonialSubtitle: 'Découvrez comment notre ERP a transformé leur entreprise',
  erpPageReadyTitle: 'Prêt à Transformer Votre Entreprise ?',
  erpPageReadyDesc: 'Rejoignez les 750+ entreprises qui nous font confiance pour leur transformation digitale',
  erpPageFreeDemoBtn: 'Demander une Démo Gratuite',
  erpPageAllSolutionsBtn: 'Voir Toutes nos Solutions',

  // ERP page - hardcoded advantages
  erpDeployTitle: 'Déploiement Rapide',
  erpDeployDesc: 'Mise en œuvre en 2-4 semaines avec formation complète de vos équipes',
  erpSupportTitle: 'Support 24/7',
  erpSupportDesc: 'Assistance technique permanente et maintenance préventive incluse',
  erpCustomTitle: '100% Personnalisable',
  erpCustomDesc: 'Adaptation complète à vos processus métiers spécifiques',
  erpCloudTitle: 'Cloud & On-Premise',
  erpCloudDesc: 'Déploiement flexible selon vos contraintes de sécurité',
  erpRoiTitle: 'ROI Garanti',
  erpRoiDesc: 'Retour sur investissement mesurable dès les premiers mois',
  erpMultiCurrTitle: 'Multi-Devises',
  erpMultiCurrDesc: 'Gestion internationale avec conformité locale garantie',
  erpTestiCompany: 'Entreprise Générale du Cameroun',
  erpTestiSector: 'Groupe industriel - 500+ employés',
  erpTestiQuote: "L'implémentation de l'ERP Alpha Solutions a révolutionné notre gestion. En 6 mois, nous avons automatisé 80% de nos processus administratifs et réduit nos coûts opérationnels de 35%. L'accompagnement de l'équipe a été exceptionnel.",
  erpTestiStat1: 'Réduction des coûts',
  erpTestiStat2: 'Processus automatisés',
  erpTestiStat3: 'Retour sur investissement',
  erpTestiPerson: 'Jean-Claude Mbarga',
  erpTestiPersonRole: 'Directeur Général',

  // Recruitment
  recruitmentRedirectTitle: 'Redirection vers notre portail de recrutement',
  recruitmentRedirectDesc: 'Vous allez être redirigé automatiquement vers notre plateforme de recrutement.',
  recruitmentPortalBtn: 'Accéder au portail de recrutement',
  recruitmentRedirectNote: 'Si la redirection ne fonctionne pas, cliquez sur le bouton ci-dessus',

  // Positioning Section
  positioningTitle: 'Pas un revendeur — un vrai partenaire métier',
  positioningSubtitle: "Découvrez ce qui nous différencie fondamentalement d'un simple revendeur de logiciels.",
  positioningResellerTitle: 'Simple revendeur',
  positioningPartnerTitle: 'Notre approche complète',
  positioningReseller1: 'Vente de licences, transaction unique',
  positioningReseller2: 'Pas de connaissance de votre métier',
  positioningReseller3: 'Suivi limité après la vente',
  positioningReseller4: 'Aucune formation incluse',
  positioningReseller5: 'Support peu réactif',
  positioningPartner1: 'Intégration technique & conseil stratégique',
  positioningPartner2: 'Parle le langage de votre secteur',
  positioningPartner3: 'Accompagnement personnalisé continu',
  positioningPartner4: 'Formation complète de vos équipes',
  positioningPartner5: 'Support local réactif, en français',
  positioningBanner: 'Notre force : Comprendre vos métiers + Maîtriser les technologies + Déployer + Former + Support continu',

  // SectorsNew Section
  sectorsNewBadge: 'Expertise sectorielle',
  sectorsNewTitle: 'Nous connaissons votre secteur',
  sectorsNewSubtitle: 'Des solutions ERP et logiciels métiers adaptés à chaque industrie, déployés par des experts qui parlent votre langage.',
  sectorsNewNotListed: "Votre secteur n'est pas dans la liste ?",
  sectorsNewNotListedSub: "Nous développons des solutions sur mesure pour tout type d'activité.",
  sectorsNewCTA: 'Discutons de votre projet',
  sectorLogistique: 'Logistique & Transport',
  sectorLogistiqueSub: 'Expéditions, flotte, carburant, transitaires',
  sectorBTPSub: 'Chantiers, sous-traitants, équipements',
  sectorRHSub: 'Paie, recrutement, gestion des talents',
  sectorImmobilierSub: 'Biens, contrats, locataires, syndic',
  sectorProductionSub: 'Planification, qualité, maintenance',
  sectorCommerceSub: 'Stock, ventes, fournisseurs, caisse',
  sectorAtelierSub: 'Ordres de réparation, pièces, devis',
  sectorCabinetsSub: 'Dossiers, facturation, missions',
  sectorHotellerieRestaurationSub: 'PMS, caisse, réservations, livraisons',
  sectorBeauteSub: 'RDV, fidélité, spa, salon',
  sectorEvenementielSub: 'Billetterie, accès, paiements',
  sectorSanteSub: 'Patients, RDV, stock médicaments',
  sectorEducationSub: 'Étudiants, notes, planning, frais',
  sectorFinanceSub: 'Portefeuille, conformité, reporting',
  sectorPrestataireServiceSub: 'Missions, facturation, projets',

  // Contact Section
  contactSectionBadge: 'Contact',
  contactSectionTitle: 'Parlons de votre projet',
  contactSectionSubtitle: 'Notre équipe vous répond sous 24h et vous propose une consultation gratuite pour analyser vos besoins.',
  contactCoords: 'Nos coordonnées',
  contactPhoneWa: 'Téléphone / WhatsApp',
  contactAddress: 'Adresse',
  contactHours: 'Horaires',
  contactHoursValue: 'Lun–Ven 8h–18h',
  contactHoursSatValue: 'Sam 9h–14h',
  contactWhatsappTitle: 'Réponse rapide garantie',
  contactWhatsappDesc: 'Préférez WhatsApp pour une réponse immédiate de notre équipe commerciale.',
  contactWhatsappBtn: 'Écrire sur WhatsApp',
  contactWhyTitle: 'Pourquoi nous contacter ?',
  contactWhy1: 'Consultation gratuite sans engagement',
  contactWhy2: '24h ouvrées',
  contactWhy3: 'Experts sectoriels disponibles',
  contactWhy4: 'Devis personnalisé selon votre activité',
  contactMeetingTitle: 'Préférez une réunion ?',
  contactMeetingDesc: "Réservez directement un créneau avec l'un de nos commerciaux. Réunion en ligne ou en présentiel à Douala.",
  contactMeetingBtn: 'Prendre rendez-vous →',
  contactFormTitle: 'Envoyer une demande',
  contactFormNameLabel: 'Nom complet',
  contactFormNamePlaceholder: 'Jean Dupont',
  contactFormCompanyLabel: 'Entreprise',
  contactFormCompanyPlaceholder: 'Nom de votre entreprise',
  contactFormPhoneLabel: 'Téléphone / WhatsApp',
  contactFormPhonePlaceholder: '+237 6XX XXX XXX',
  contactFormEmailLabel: 'Email',
  contactFormEmailPlaceholder: 'votre@email.com',
  contactFormSectorLabel: "Secteur d'activité",
  contactFormSectorPlaceholder: 'Sélectionner votre secteur',
  contactFormRequestLabel: 'Type de demande',
  contactFormRequestPlaceholder: 'Sélectionner le type',
  contactFormMessageLabel: 'Message',
  contactFormMessagePlaceholder: 'Décrivez brièvement vos besoins et objectifs...',
  contactFormCharsLeft: 'caractères',
  contactFormSubmit: 'Envoyer ma demande',
  contactFormSubmitting: 'Envoi en cours...',
  contactFormSuccessTitle: 'Demande envoyée !',
  contactFormSuccessDesc: 'Notre équipe vous contacte sous 24h ouvrées.',
  contactFormSuccessBtn: 'Envoyer une autre demande',
  contactFormErrorMsg: 'Une erreur est survenue. Veuillez réessayer ou nous contacter directement.',

  // Sector pages - common extended
  sectorAnalyzeNeeds: 'Analyse de vos besoins',
  sectorAnalyzeNeedsDesc: "Nous étudions votre activité pour comprendre vos défis spécifiques et vos objectifs.",
  sectorExpertReco: 'Recommandation experte',
  sectorExpertRecoDesc: "Nous sélectionnons les meilleurs systèmes adaptés à votre type d'activité et budget.",
  sectorIntegration: 'Intégration & déploiement',
  sectorIntegrationDesc: 'Installation complète, configuration personnalisée et migration de vos données.',
  sectorFormationSupport: 'Formation & support',
  sectorFormationSupportDesc: 'Formation de vos équipes et assistance continue pour garantir votre succès.',
  sectorHowWeHelp: 'Comment Alpha Solutions Vous Aide',
  sectorCustomizable: "Solutions personnalisables selon votre type d'activité",
  sectorSatisfiedSince: 'Client satisfait depuis',
  tabFonctionnalites: 'Fonctionnalités Détaillées',
  tabAvantages: 'Ce que nous apportons',
  tabTemoignage: 'Client Satisfait',

  // Hotellerie sector
  hotellerieSectorHeroTitle: 'Solutions Gestion Hôtelière',
  hotellerieSectorHeroDesc: 'Systèmes complets pour transformer votre établissement : PMS, réservations, facturation, revenue management et service client digital.',
  hotellerieFeaturesTitle: "Fonctionnalités Complètes pour l'Hôtellerie",
  hotellerieFeaturesSubtitle: "Alpha Solutions intègre des systèmes de gestion hôtelière éprouvés et adaptés au marché africain",
  hotellerieFeaturesCustom: "Solutions personnalisables selon votre type d'établissement",
  hotellerieCtaTitle: 'Prêt à transformer votre hôtel ?',
  hotellerieCtaDesc: 'Rejoignez nos clients satisfaits. Demandez votre démo personnalisée.',
  hotellerieAvantagesTitle: 'Ce que nous vous apportons',
  hotellerieAvantagesSubtitle: "Notre expertise de 8 ans dans l'hôtellerie pour transformer votre établissement",
  hotellerieAdv1Title: 'Gain de Temps Majeur',
  hotellerieAdv1Desc: 'Réduction de 80% du temps de clôture de caisse (de 5h à 20 minutes)',
  hotellerieAdv2Title: 'Optimisation Occupation',
  hotellerieAdv2Desc: "Augmentation moyenne de 30% du taux d'occupation grâce au revenue management",
  hotellerieAdv3Title: 'Satisfaction Client',
  hotellerieAdv3Desc: 'Amélioration de 40% de la satisfaction grâce à un service plus rapide et personnalisé',
  hotellerieAdv4Title: 'Augmentation Revenus',
  hotellerieAdv4Desc: "Croissance moyenne de 25% du chiffre d'affaires avec nos systèmes intégrés",
  hotellerieAdv5Title: 'Réduction Erreurs',
  hotellerieAdv5Desc: 'Diminution de 85% des erreurs de réservation et facturation',
  hotellerieAdv6Title: 'Visibilité Complète',
  hotellerieAdv6Desc: 'Tableaux de bord en temps réel pour piloter efficacement votre établissement',
  hotellerieSol1: 'Réduction drastique du temps de clôture de caisse',
  hotellerieSol2: 'Automatisation des processus de réservation',
  hotellerieSol3: "Amélioration de l'expérience client",
  hotellerieSol4: "Optimisation du taux d'occupation",
  hotellerieSol5: 'Gestion centralisée multi-canaux',
  hotellerieSol6: 'Reporting en temps réel pour la direction',
  hotellerieTestiQuote: "Grâce à Alpha Solutions, notre complexe hôtelier a été complètement transformé. Le système de réservation intégré et la gestion clientèle optimisée nous ont permis d'augmenter notre taux d'occupation de 40% en 6 mois.",
  hotellerieTestiPerson: 'Jean Michel Tchatchoua',
  hotellerieTestiRole2: 'Propriétaire - Elabi Pool & Spa',
  hotellerieTestiSince: 'Client satisfait depuis 2021',

  // Restauration sector
  restaurationHeroTitle: 'Solutions Gestion de Restaurant',
  restaurationHeroDesc: 'Systèmes complets pour optimiser votre restaurant : POS, gestion des commandes, contrôle des stocks, et bien plus',
  restaurationFeaturesTitle: 'Fonctionnalités Complètes pour Restaurants',
  restaurationFeaturesSubtitle: "Alpha Solutions intègre des systèmes de gestion restaurant éprouvés et adaptés au marché africain",
  restaurationAvantagesTitle: 'Ce que nous apportons à votre restaurant',
  restaurationAvantagesSubtitle: "Transformez votre restaurant avec notre expertise de 8 années dans l'intégration de solutions",
  restaurationCtaTitle: "Transformez Votre Restaurant Dès Aujourd'hui",
  restaurationCtaDesc: "Rejoignez les restaurateurs qui ont augmenté leur CA de 30% avec nos solutions intégrées",
  restaurationDemoBtn: 'Demander une Démo Gratuite',
  restaurationAllSolutions: 'Voir Toutes nos Solutions',
  restaurationTestimonialBtn: 'Voir Témoignage Client',

  // Evenementiel sector
  evenementielHeroTitle: 'Solutions Événementiel',
  evenementielHeroDesc: "Spécialistes de la sécurisation des paiements pour événements grand public. Billetterie en ligne, contrôle d'accès et gestion complète.",
  evenementielSpecialite: 'Notre Spécialité : Sécurisation des Paiements',
  evenementielSpecialiteDesc: 'Nous sommes très demandés pour fournir des solutions de sécurisation des paiements dans les événements grand public comme SUNDAYZ, White Bloom, Coco Beach',
  evenementielFeaturesTitle: "Solution Complète pour l'Événementiel",
  evenementielFeaturesSubtitle: 'Plus de 16 fonctionnalités spécialisées pour gérer vos événements de A à Z, avec une attention particulière sur la sécurisation des paiements.',
  evenementielAvantagesTitle: 'Ce que nous vous apportons',
  evenementielAvantagesSubtitle: "Notre expertise de 8 ans dans l'événementiel pour sécuriser vos événements",
  evenementielCtaTitle: 'Prêt à sécuriser vos événements ?',
  evenementielCtaDesc: 'Rejoignez SUNDAYZ et nos autres clients. Organisez vos événements en toute sérénité.',
  evenementielSecureBtn: 'Sécuriser Mon Événement',
  evenementielAllSolutions: 'Toutes nos Solutions',
  evenementielDemoBtn: 'Demander une démo',
  evenementielConsultBtn: 'Demander une consultation',
  evenementielDiscoverBtn: 'Découvrir nos solutions',

  // Footer hardcoded
  footerTagline: 'Intégrateur ERP & Partenaire Digital',
  footerAddress: '822 rue Joffre, Akwa — Douala, Cameroun',
  footerCopyright: '© 2026 Alpha Solutions — Intégrateur ERP & Partenaire Digital.',

  // References - Testimonials
  refTestimonial1Quote: "Système de réservation intégré et gestion clientèle optimisée pour notre complexe. Alpha Solutions a transformé notre façon de travailler.",
  refTestimonial2Quote: "Installation rapide POS — commandes optimisées et service client exceptionnel. On ne peut plus s'en passer.",
  refTestimonial3Quote: "Gestion complète de notre spa avec suivi clientèle personnalisé et agenda RDV optimisé. Nos équipes adorent l'outil.",
  refTestimonial4Quote: "Avant l'ERP on gérait tout sur Excel. Maintenant on visualise la rentabilité par véhicule en temps réel.",
  refTestimonial5Quote: "Suivi locataires automatisé, relances automatiques, contrats centralisés. Indispensable.",
  refTestimonial6Quote: "Gestion stock et ventes révolutionnée, suivi fournisseurs en temps réel. ROI visible dès le premier mois.",
  refSectorHotelRestauration: 'Hôtellerie & Restauration',
  refSectorBeaute: 'Beauté & Bien-être',
  refSectorLogistique: 'Logistique & Transport',
  refSectorProduction: 'Production & Industrie',
  refSectorImmobilier: 'Immobilier',
  refSectorCommerce: 'Commerce & Distribution',
  refAndManyMore: "et bien d'autres",

  // Partners descriptions
  partnerCaviusDesc: "Solutions ERP & gestion d'entreprise",
  partnerAwebstarDesc: 'Développement web & digital',
  partnerRedsparkDesc: 'Solutions de paiement & fintech',
  partnerPaymeDesc: 'Paiement mobile & digital',
  partnerDigiticaDesc: 'Transformation digitale & automation',
  partnerAtlantaDesc: 'Infrastructure & informatique',
  partnerKaeyrosDesc: 'Analytics & business intelligence',

  // About page - hardcoded section
  aboutExpertiseSectionTitle: 'Notre Expertise',
  aboutExpertiseSectionSubtitle: "8 années d'expérience au service de la transformation digitale des entreprises",
  aboutExpertise1Title: 'Intégration de Solutions',
  aboutExpertise1Desc: 'Sélection et intégration de systèmes ERP, CRM, comptabilité adaptés à vos besoins',
  aboutExpertise2Title: 'Support 24/7',
  aboutExpertise2Desc: 'Assistance technique permanente et formation continue de vos équipes',
  aboutExpertise3Title: 'Conseil Technologique',
  aboutExpertise3Desc: 'Guidance experte pour naviguer dans le monde complexe des technologies',
  aboutExpertise4Title: 'Adaptation Locale',
  aboutExpertise4Desc: "Technologies mondiales adaptées à l'environnement business africain",
  aboutStatsSection2Title: 'Alpha Solutions en Chiffres',
  aboutStatsSection2Subtitle: 'Des résultats qui parlent de notre expertise et de la confiance de nos clients',
  aboutStatsSection2Desc: '750+ entreprises nous font confiance',
  aboutStatsSection2SubDesc: 'Des PME aux grandes entreprises, nos clients témoignent de notre expertise et de notre engagement à leurs côtés pour leur croissance.',

  // Solutions page - hardcoded sections
  solErpSystemsTitle: 'Systèmes ERP',
  solErpSystemsDesc: "Centralisez et optimisez toutes les opérations de votre entreprise avec un système ERP intégré",
  solErpDiscover: 'Découvrir notre solution ERP',
  solCrmSystemsTitle: 'Systèmes CRM',
  solCrmSystemsDesc: 'Transformez vos relations clients et boostez vos performances commerciales',
  solCrmDiscover: 'Découvrir notre solution CRM',
  solAccountingTitle: 'Systèmes Comptabilité & Finance',
  solAccountingDesc: 'Automatisez votre comptabilité et obtenez une visibilité financière complète',
  solHRTitle: 'Systèmes RH & Paie',
  solHRDesc: 'Simplifiez la gestion de vos ressources humaines et automatisez la paie',
  solProjectTitle: 'Systèmes de Gestion de Projets',
  solProjectDesc: 'Planifiez, suivez et contrôlez vos projets pour garantir leur succès',
  solRequestDemo: 'Demander une démo',
  solRequestDemoBtn: 'Demander une démo',
  solCentralData: 'Centralisation des Données',
  solCentralDataDesc: 'Toutes vos données métier dans un système unique et cohérent',
  solFinancialVis: 'Visibilité Financière',
  solFinancialVisDesc: 'Reporting en temps réel pour une meilleure prise de décision',
  solOpsControl: 'Contrôle Opérationnel',
  solOpsControlDesc: 'Maîtrisez tous les processus de votre entreprise',
  solBetterPlanning: 'Meilleure Planification',
  solBetterPlanningDesc: 'Anticipez et planifiez vos activités stratégiques',
  solClientRel: 'Gestion Relations Clients',
  solClientRelDesc: 'Centralisez toutes les informations de vos clients',
  solSalesTrack: 'Suivi des Ventes',
  solSalesTrackDesc: 'Pipeline commercial et opportunités en temps réel',
  solCommHistory: 'Historique Communication',
  solCommHistoryDesc: 'Toutes les interactions clients centralisées',
  solMarkAnalysis: 'Analyses Marketing',
  solMarkAnalysisDesc: 'Insights et prévisions pour vos campagnes',
  solAutoAccounting: 'Comptabilité Automatisée',
  solAutoAccountingDesc: 'Saisie automatique et réconciliation bancaire',
  solFinancialReport: 'Reporting Financier',
  solFinancialReportDesc: 'États financiers instantanés et personnalisables',
  solCompliance: 'Conformité Réglementaire',
  solComplianceDesc: 'Respect des normes comptables locales',
  solDashboards: 'Tableaux de Bord',
  solDashboardsDesc: 'Indicateurs financiers en temps réel',
  solEmpMgmt: 'Gestion des Employés',
  solEmpMgmtDesc: 'Dossiers complets et historique du personnel',
  solPayrollAuto: 'Automatisation Paie',
  solPayrollAutoDesc: 'Calcul automatique des salaires et charges',
  solAttendance: 'Suivi Présences',
  solAttendanceDesc: 'Gestion des congés, absences et pointages',
  solHRReport: 'Reporting RH',
  solHRReportDesc: 'Analyses et statistiques du personnel',
  solPlanning: 'Planification',
  solPlanningDesc: 'Ordonnancement des tâches et ressources',
  solCostTrack: 'Suivi des Coûts',
  solCostTrackDesc: 'Contrôle budgétaire et analyse des dépenses',
  solTeamCollab: 'Collaboration Équipe',
  solTeamCollabDesc: 'Communication et partage de documents',
  solPerfMonitor: 'Monitoring Performance',
  solPerfMonitorDesc: 'Indicateurs de progression et alertes',
  solHotelTitle: 'Logiciels de Gestion Hôtelière',
  solHotelDesc: 'Systèmes complets pour gérer tous les aspects de votre établissement hôtelier, du PMS aux services clients',
  solRetailTitle: 'Systèmes de Vente au Détail & POS',
  solRetailDesc: 'Solutions complètes pour gérer vos points de vente, stocks, et optimiser vos opérations commerciales',
  solSchoolTitle: 'Logiciels de Gestion Scolaire',
  solSchoolDesc: 'Systèmes complets pour digitaliser la gestion de votre établissement éducatif',
  solClinicTitle: 'Systèmes Cliniques & Pharmacies',
  solClinicDesc: 'Solutions complètes pour digitaliser la gestion de votre établissement de santé',
  solServiceBizTitle: 'Logiciels pour Entreprises de Services',
  solServiceBizDesc: 'Solutions complètes pour gérer vos clients, projets, facturation et opérations de service',
  solSeeHotelDetails: "Voir les détails Hôtellerie",
  solSeeRetailDetails: 'Voir les détails Commerce',
  solSeeEduDetails: 'Voir les détails Éducation',
  solSeeHealthDetails: 'Voir les détails Santé',
  solReservations: 'Réservations',
  solRoomMgmt: 'Gestion des Chambres',
  solBilling: 'Facturation',
  solGuestServices: 'Services Clients',
  solCashSystem: 'Système de Caisse',
  solStockTrack: 'Suivi des Stocks',
  solSalesAnalysis: 'Analyses des Ventes',
  solMultiStore: 'Gestion Multi-magasins',
  solStudentFiles: 'Dossiers Étudiants',
  solAttendanceMgmt: 'Gestion des Présences',
  solGradingSystem: 'Système de Notation',
  solParentComm: 'Communication Parents',
  solPatientFiles: 'Dossiers Patients',
  solPrescriptions: 'Gestion des Prescriptions',
  solAppointments: 'Gestion des Rendez-vous',
  solPharmacyInv: 'Inventaire Pharmacie',
  solClientMgmt: 'Gestion Clients',
  solInvoicing: 'Facturation',
  solTaskMgmt: 'Gestion des Tâches',
  solProjectTrack: 'Suivi de Projets',
  solProductPhare: 'PRODUIT PHARE',
  solCompleteSolution: 'SOLUTION COMPLÈTE',

  // Solutions page - CRM cards (hardcoded)
  solCrmClientRel: 'Gestion Relations Clients',
  solCrmClientRelDesc: 'Centralisez toutes les informations de vos clients',
  solCrmSalesTrack: 'Suivi des Ventes',
  solCrmSalesTrackDesc: 'Pipeline commercial et opportunités en temps réel',
  solCrmCommHistory: 'Historique Communication',
  solCrmCommHistoryDesc: 'Toutes les interactions clients centralisées',
  solCrmMarkAnalysis: 'Analyses Marketing',
  solCrmMarkAnalysisDesc: 'Insights et prévisions pour vos campagnes',

  // Solutions page - Accounting cards (hardcoded)
  solAccAutoAccounting: 'Comptabilité Automatisée',
  solAccAutoAccountingDesc: 'Saisie automatique et réconciliation bancaire',
  solAccFinancialReport: 'Reporting Financier',
  solAccFinancialReportDesc: 'États financiers instantanés et personnalisables',
  solAccCompliance: 'Conformité Réglementaire',
  solAccComplianceDesc: 'Respect des normes comptables locales',
  solAccDashboards: 'Tableaux de Bord',
  solAccDashboardsDesc: 'Indicateurs financiers en temps réel',
  solAccDemoBtn: 'Demander une démo',

  // Solutions page - HR cards (hardcoded)
  solHrEmpMgmt: 'Gestion des Employés',
  solHrEmpMgmtDesc: 'Dossiers complets et historique du personnel',
  solHrPayrollAuto: 'Automatisation Paie',
  solHrPayrollAutoDesc: 'Calcul automatique des salaires et charges',
  solHrAttendance: 'Suivi Présences',
  solHrAttendanceDesc: 'Gestion des congés, absences et pointages',
  solHrReporting: 'Reporting RH',
  solHrReportingDesc: 'Analyses et statistiques du personnel',

  // Solutions page - Project Mgmt cards (hardcoded)
  solProjPlanning: 'Planification',
  solProjPlanningDesc: 'Ordonnancement des tâches et ressources',
  solProjCostTrack: 'Suivi des Coûts',
  solProjCostTrackDesc: 'Contrôle budgétaire et analyse des dépenses',
  solProjTeamCollab: 'Collaboration Équipe',
  solProjTeamCollabDesc: 'Communication et partage de documents',
  solProjPerfMonitor: 'Monitoring Performance',
  solProjPerfMonitorDesc: 'Indicateurs de progression et alertes',

  // Solutions page - Hotel detail cards (hardcoded)
  solHotelReservationsTitle: 'Réservations',
  solHotelReservationsFeat1: 'Système de réservation en ligne',
  solHotelReservationsFeat2: 'Gestion des groupes et événements',
  solHotelReservationsFeat3: 'Confirmations automatiques',
  solHotelReservationsFeat4: 'Intégration multi-canaux',
  solHotelRoomTitle: 'Gestion des Chambres',
  solHotelRoomFeat1: 'Statut en temps réel',
  solHotelRoomFeat2: 'Coordination housekeeping',
  solHotelRoomFeat3: 'Maintenance préventive',
  solHotelRoomFeat4: 'Gestion des catégories',
  solHotelBillingTitle: 'Facturation',
  solHotelBillingFeat1: 'Facturation automatique',
  solHotelBillingFeat2: 'Gestion des extras',
  solHotelBillingFeat3: 'Calcul automatique des taxes',
  solHotelBillingFeat4: 'Factures personnalisées',
  solHotelGuestTitle: 'Services Clients',
  solHotelGuestFeat1: 'CRM hôtelier intégré',
  solHotelGuestFeat2: 'Programme de fidélité',
  solHotelGuestFeat3: 'Préférences clients',
  solHotelGuestFeat4: 'Historique des séjours',

  // Solutions page - Retail detail cards (hardcoded)
  solRetailCashTitle: 'Système de Caisse',
  solRetailCashFeat1: 'Interface tactile rapide',
  solRetailCashFeat2: 'Paiements multiples',
  solRetailCashFeat3: 'Gestion des promotions',
  solRetailCashFeat4: 'Programme de fidélité',
  solRetailStockTitle: 'Suivi des Stocks',
  solRetailStockFeat1: 'Inventaire temps réel',
  solRetailStockFeat2: 'Alertes de réapprovisionnement',
  solRetailStockFeat3: 'Traçabilité complète',
  solRetailStockFeat4: 'Gestion des lots',
  solRetailSalesTitle: 'Analyses des Ventes',
  solRetailSalesFeat1: 'Rapports de ventes détaillés',
  solRetailSalesFeat2: 'Produits les plus vendus',
  solRetailSalesFeat3: 'Analyse de rentabilité',
  solRetailSalesFeat4: 'Prévisions de ventes',
  solRetailMultiTitle: 'Gestion Multi-magasins',
  solRetailMultiFeat1: 'Vue consolidée',
  solRetailMultiFeat2: 'Transferts inter-magasins',
  solRetailMultiFeat3: 'Gestion centralisée des prix',
  solRetailMultiFeat4: 'Reporting comparatif',

  // Solutions page - School detail cards (hardcoded)
  solSchoolStudentsTitle: 'Dossiers Étudiants',
  solSchoolStudentsFeat1: 'Base de données complète',
  solSchoolStudentsFeat2: 'Historique académique',
  solSchoolStudentsFeat3: 'Informations personnelles',
  solSchoolStudentsFeat4: 'Documents administratifs',
  solSchoolAttTitle: 'Gestion des Présences',
  solSchoolAttFeat1: 'Pointage électronique',
  solSchoolAttFeat2: 'Suivi des absences',
  solSchoolAttFeat3: 'Alertes automatiques',
  solSchoolAttFeat4: 'Rapports de présence',
  solSchoolGradesTitle: 'Système de Notation',
  solSchoolGradesFeat1: 'Saisie des notes en ligne',
  solSchoolGradesFeat2: 'Calcul automatique des moyennes',
  solSchoolGradesFeat3: 'Bulletins personnalisables',
  solSchoolGradesFeat4: 'Suivi de progression',
  solSchoolParentsTitle: 'Communication Parents',
  solSchoolParentsFeat1: 'Portail parents en ligne',
  solSchoolParentsFeat2: 'Notifications automatiques',
  solSchoolParentsFeat3: 'Messagerie intégrée',
  solSchoolParentsFeat4: 'Accès aux résultats',

  // Solutions page - Clinic detail cards (hardcoded)
  solClinicPatientsTitle: 'Dossiers Patients',
  solClinicPatientsFeat1: 'Dossiers médicaux électroniques',
  solClinicPatientsFeat2: 'Historique médical complet',
  solClinicPatientsFeat3: 'Sécurité et confidentialité',
  solClinicPatientsFeat4: 'Accès rapide aux informations',
  solClinicPrescTitle: 'Gestion des Prescriptions',
  solClinicPrescFeat1: 'Prescriptions électroniques',
  solClinicPrescFeat2: 'Base de données médicaments',
  solClinicPrescFeat3: "Alertes d'interactions",
  solClinicPrescFeat4: 'Historique des prescriptions',
  solClinicApptTitle: 'Gestion des Rendez-vous',
  solClinicApptFeat1: 'Agenda médical en ligne',
  solClinicApptFeat2: 'Réservation en ligne',
  solClinicApptFeat3: 'Rappels automatiques',
  solClinicApptFeat4: "Gestion des salles d'attente",
  solClinicPharmTitle: 'Inventaire Pharmacie',
  solClinicPharmFeat1: 'Gestion des stocks médicaments',
  solClinicPharmFeat2: "Suivi des dates d'expiration",
  solClinicPharmFeat3: 'Alertes de réapprovisionnement',
  solClinicPharmFeat4: 'Traçabilité complète',

  // Solutions page - Service biz detail cards (hardcoded)
  solSvcClientTitle: 'Gestion Clients',
  solSvcClientFeat1: 'Base de données clients',
  solSvcClientFeat2: 'Historique des interactions',
  solSvcClientFeat3: 'Gestion des contrats',
  solSvcClientFeat4: 'Suivi de satisfaction',
  solSvcBillingTitle: 'Facturation',
  solSvcBillingFeat1: 'Devis et factures automatiques',
  solSvcBillingFeat2: 'Facturation récurrente',
  solSvcBillingFeat3: 'Suivi des paiements',
  solSvcBillingFeat4: 'Relances automatiques',
  solSvcTaskTitle: 'Gestion des Tâches',
  solSvcTaskFeat1: 'Planification des interventions',
  solSvcTaskFeat2: 'Attribution aux équipes',
  solSvcTaskFeat3: 'Suivi de progression',
  solSvcTaskFeat4: 'Notifications automatiques',
  solSvcProjectTitle: 'Suivi de Projets',
  solSvcProjectFeat1: 'Gestion de projets clients',
  solSvcProjectFeat2: 'Suivi du temps passé',
  solSvcProjectFeat3: 'Contrôle des budgets',
  solSvcProjectFeat4: 'Rapports de rentabilité',
  solSvcDemoBtn: 'Demander une démo',

  // Filter sector labels (solutions page)
  filterSectorHotellerie: 'Hôtellerie',
  filterSectorRestauration: 'Restauration',
  filterSectorBeaute: 'Beauté & Bien-être',
  filterSectorEvenementiel: 'Événementiel',
  filterSectorImmobilier: 'Immobilier',
  filterSectorCommerce: 'Commerce & Distribution',
  filterSectorProduction: 'Production & Industrie',
  filterSectorEducation: 'Éducation',
  filterSectorSante: 'Santé',
  filterSectorTransport: 'Transport & Logistique',
  filterSectorFinance: 'Services Financiers',
  filterSectorAdministration: 'Administration Publique',

  // CRM page
  crmPageTitle: 'CRM - Gestion Client',
  crmPageSubtitle: 'Optimisez vos relations clients et boostez vos ventes avec notre solution CRM complète',
  crmPageDemoBtn: 'Demander une Démo',
  crmPageTestimonialBtn: 'Voir Témoignage Client',
  crmPageTabFeatures: 'Fonctionnalités',
  crmPageTabAdvantages: 'Nos Avantages',
  crmPageTabTestimonial: 'Client Satisfait',
  crmPageFeaturesTitle: '15+ Fonctionnalités CRM',
  crmPageFeaturesSubtitle: 'Une solution complète pour optimiser vos relations clients',
  crmPageCustomBadge: '100% Personnalisables selon vos besoins',
  crmPageAdvTitle: 'Pourquoi Choisir Notre CRM ?',
  crmPageAdvSubtitle: 'Augmentez vos ventes de 40% avec notre accompagnement expert',
  crmPageTestiTitle: 'Client Satisfait',
  crmPageTestiSubtitle: 'Découvrez comment notre CRM a boosté leurs performances commerciales',
  crmPageCTATitle: "Boostez Vos Ventes Dès Aujourd'hui",
  crmPageCTASubtitle: 'Rejoignez les entreprises qui ont augmenté leurs ventes de 40% avec notre CRM',
  crmPageFreeDemoBtn: 'Demander une Démo Gratuite',
  crmPageAllSolutionsBtn: 'Voir Toutes nos Solutions',
  crmAdv1Title: '+40% de Ventes',
  crmAdv1Desc: "Augmentation moyenne des ventes grâce à l'optimisation du pipeline",
  crmAdv2Title: 'Gain de Temps',
  crmAdv2Desc: 'Automatisation des tâches répétitives, plus de temps pour vendre',
  crmAdv3Title: 'Satisfaction Client',
  crmAdv3Desc: "Amélioration de l'expérience client et fidélisation renforcée",
  crmAdv4Title: 'Mobilité Totale',
  crmAdv4Desc: 'Accès complet depuis mobile pour vos équipes terrain',
  crmAdv5Title: 'Intelligence Artificielle',
  crmAdv5Desc: 'Prédictions de ventes et recommandations automatiques',
  crmAdv6Title: 'Intégrations',
  crmAdv6Desc: 'Connexion avec vos outils existants (email, comptabilité, etc.)',
  crmTestiClientName: 'TelecomPlus Cameroun',
  crmTestiClientSector: 'Télécommunications - 150+ commerciaux',
  crmTestiQuote: "Depuis l'implémentation du CRM Alpha Solutions, nos équipes commerciales ont augmenté leurs performances de 45%. La visibilité sur le pipeline et l'automatisation des relances ont transformé notre approche commerciale. Un investissement rentabilisé en 4 mois !",
  crmTestiStat1Value: '+45%',
  crmTestiStat1Label: 'Augmentation des ventes',
  crmTestiStat2Value: '4 mois',
  crmTestiStat2Label: 'Retour sur investissement',
  crmTestiStat3Value: '92%',
  crmTestiStat3Label: 'Satisfaction équipes',
  crmTestiPersonName: 'Marie-Claire Nkomo',
  crmTestiPersonRole: 'Directrice Commerciale',

  // Header CTA button
  headerBookRdv: 'Prendre RDV',
  talkWithUs: 'Parler avec nous',

  // Sector pages - Beaute
  beauteHeroTitle: 'Solutions Beauté & Bien-être',
  beauteHeroDesc: 'Transformez votre salon avec nos solutions de gestion des rendez-vous, fidélisation client, cartes cadeaux et marketing automatisé.',
  beauteFeaturesTitle: 'Fonctionnalités Avancées pour la Beauté & Bien-être',
  beauteFeaturesSubtitle: "Plus de 18 fonctionnalités spécialisées pour gérer efficacement votre salon, spa ou institut de beauté et maximiser votre chiffre d'affaires.",
  beauteCustomBadge: "Fonctionnalités 100% personnalisables selon votre type d'établissement",
  beauteWeBringTitle: 'Ce que nous vous apportons',
  beauteWeBringSubtitle: 'Notre expertise de 8 ans dans la beauté pour transformer votre salon',
  beauteTestiName: 'Dr Kamga',
  beauteTestiRole: 'Propriétaire - Medispa',
  beauteTestiQuote: "La solution Alpha Solutions a révolutionné notre medispa. La gestion automatisée des rendez-vous et le suivi clientèle personnalisé nous ont permis d'améliorer considérablement l'expérience de nos patients et d'optimiser notre planning.",
  beauteSatisfied: 'Client satisfait depuis 2022',
  beauteCtaTitle: 'Prêt à transformer votre salon ?',
  beauteCtaDesc: 'Rejoignez nos clients satisfaits et augmentez vos revenus. Demandez votre démo personnalisée.',
  beauteSol1: 'Augmentation du taux de rétention client',
  beauteSol2: 'Optimisation du planning et réduction des temps morts',
  beauteSol3: 'Automatisation des campagnes marketing',
  beauteSol4: 'Gestion complète des stocks et produits',
  beauteSol5: 'Programme de fidélité personnalisé',
  beauteSol6: 'Reporting détaillé pour optimiser les performances',

  // Sector pages - Commerce
  commerceHeroTitle: 'Solutions Commerce & Distribution',
  commerceHeroDesc: 'Systèmes complets pour gérer votre commerce : stocks, ventes, fournisseurs, e-commerce et multi-magasins',
  commerceFeaturesTitle: 'Fonctionnalités Complètes pour Commerce & Distribution',
  commerceFeaturesSubtitle: "Alpha Solutions intègre des systèmes de gestion commerciale éprouvés et adaptés au marché africain",
  commerceCustomBadge: 'Solutions personnalisables selon votre type de commerce',
  commerceWeBringTitle: 'Ce que nous apportons à votre commerce',
  commerceWeBringSubtitle: "Transformez votre commerce avec notre expertise de 8 années dans l'intégration de solutions",
  commerceTestiName: 'Gaby Mbomgnin',
  commerceTestiRole: 'Propriétaire - MD Distribution',
  commerceTestiQuote: "Grâce à Alpha Solutions, MD Distribution a révolutionné sa gestion. Le suivi en temps réel des stocks et la gestion automatisée des fournisseurs nous ont permis d'optimiser nos opérations et d'augmenter le chiffre d'affaires de 35%.",
  commerceSatisfied: 'Client satisfait depuis 2020',
  commerceCtaTitle: 'Prêt à Optimiser Votre Commerce ?',
  commerceCtaDesc: 'Rejoignez les entreprises qui nous font confiance pour leur transformation digitale',
  commerceAdv1Title: 'Optimisation des Stocks',
  commerceAdv1Desc: 'Réduction de 30% des ruptures de stock et 25% des surstocks grâce aux alertes automatiques et prévisions',
  commerceAdv2Title: 'Augmentation des Ventes',
  commerceAdv2Desc: "Croissance moyenne de 25% du chiffre d'affaires avec nos systèmes de gestion et e-commerce intégré",
  commerceAdv3Title: 'Fidélisation Client',
  commerceAdv3Desc: "Programme de fidélité intégré pour augmenter la rétention de 40% et les achats répétés",
  commerceAdv4Title: 'Gain de Temps',
  commerceAdv4Desc: 'Automatisation des tâches répétitives permettant un gain de 15 heures par semaine',

  // Sector pages - Sante
  santeHeroTitle: 'Solutions Santé',
  santeHeroDesc: 'Modernisez votre établissement de santé avec nos solutions de gestion médicale et dossiers patients',
  santeSolutionsTitle: 'Nos Solutions Santé',
  santeSolutionsSubtitle: 'Une plateforme complète pour la gestion moderne de votre établissement de santé',
  santeWhyTitle: 'Pourquoi Choisir Nos Solutions ?',
  santeTestiName: 'Pharmacie de Gaulle',
  santeTestiRole: 'Santé & Pharmacie',
  santeTestiQuote: "La digitalisation de notre pharmacie avec Alpha Solutions a transformé notre pratique. La gestion automatisée des stocks, des péremptions et des ordonnances nous a fait gagner un temps précieux pour mieux servir nos patients.",
  santeSatisfied: 'Client satisfait depuis 2021',
  santeCtaTitle: 'Prêt à Moderniser Votre Établissement de Santé ?',
  santeCtaDesc: 'Rejoignez les professionnels de santé qui nous font confiance',
  santeAdv1Title: 'Sécurité Maximale',
  santeAdv1Desc: 'Conformité RGPD et sécurisation des données médicales',
  santeAdv2Title: 'Efficacité +40%',
  santeAdv2Desc: 'Amélioration de l\'efficacité des consultations',
  santeAdv3Title: 'Qualité des Soins',
  santeAdv3Desc: 'Amélioration de la qualité des soins grâce au numérique',
  santeAdv4Title: 'Satisfaction Patients',
  santeAdv4Desc: 'Meilleure expérience patient avec les services numériques',

  // Sector pages - Education
  educationHeroTitle: 'Solutions Éducation',
  educationHeroDesc: 'Modernisez votre établissement scolaire avec nos solutions de gestion étudiante et pédagogique',
  educationSolutionsTitle: 'Nos Solutions Éducation',
  educationSolutionsSubtitle: 'Une plateforme complète pour la gestion moderne de votre établissement éducatif',
  educationWhyTitle: 'Pourquoi Choisir Nos Solutions ?',
  educationTestiName: 'Groupe Scolaire Etoile',
  educationTestiRole: 'Établissement Éducatif',
  educationTestiQuote: "La digitalisation de notre école avec Alpha Solutions a révolutionné notre gestion. Les parents peuvent maintenant suivre les notes de leurs enfants en temps réel, et notre administration est devenue 100% numérique.",
  educationSatisfied: 'Client satisfait depuis 2021',
  educationCtaTitle: 'Prêt à Moderniser Votre Établissement ?',
  educationCtaDesc: 'Rejoignez les établissements éducatifs qui nous font confiance',
  educationAdv1Title: 'Digitalisation Complète',
  educationAdv1Desc: 'Transformation numérique de tous les processus éducatifs',
  educationAdv2Title: 'Gain de Temps',
  educationAdv2Desc: 'Automatisation de 70% des tâches administratives',
  educationAdv3Title: 'Suivi Personnalisé',
  educationAdv3Desc: 'Accompagnement individualisé de chaque étudiant',
  educationAdv4Title: 'Communication Améliorée',
  educationAdv4Desc: 'Meilleure collaboration entre tous les acteurs',

  // Sector pages - Transport
  transportHeroTitle: 'Solutions Transport & Logistique',
  transportHeroDesc: "Optimisez votre chaîne logistique avec nos solutions de gestion de flotte et d'optimisation des livraisons",
  transportSolutionsTitle: 'Nos Solutions Transport & Logistique',
  transportSolutionsSubtitle: 'Une suite complète pour optimiser votre chaîne logistique et transport',
  transportWhyTitle: 'Pourquoi Choisir Nos Solutions ?',
  transportTestiName: 'AQUAVITA',
  transportTestiRole: 'Transport & Logistique',
  transportTestiQuote: "Grâce à Alpha Solutions, nous avons optimisé nos routes de livraison et réduit nos coûts de transport de 30%. Le suivi en temps réel de notre flotte nous permet d'offrir un service exceptionnel à nos clients.",
  transportSatisfied: 'Client satisfait depuis 2020',
  transportCtaTitle: 'Prêt à Optimiser Votre Logistique ?',
  transportCtaDesc: 'Rejoignez les entreprises de transport qui nous font confiance',
  transportAdv1Title: 'Réduction Coûts',
  transportAdv1Desc: "Diminution de 25% des coûts de transport grâce à l'optimisation",
  transportAdv2Title: 'Efficacité +30%',
  transportAdv2Desc: 'Amélioration de l\'efficacité des livraisons',
  transportAdv3Title: 'Satisfaction Client',
  transportAdv3Desc: 'Amélioration de la satisfaction grâce au suivi temps réel',
  transportAdv4Title: 'Sécurité Renforcée',
  transportAdv4Desc: 'Amélioration de la sécurité de la flotte et des marchandises',

  // Sector pages - Finance
  financeHeroTitle: 'Solutions Services Financiers',
  financeHeroDesc: 'Optimisez vos services financiers avec nos solutions de gestion de portefeuille et conformité réglementaire',
  financeSolutionsTitle: 'Nos Solutions Services Financiers',
  financeSolutionsSubtitle: 'Une plateforme complète pour la gestion moderne des services financiers',
  financeWhyTitle: 'Pourquoi Choisir Nos Solutions ?',
  financeTestiName: 'CN 237',
  financeTestiRole: 'Services Financiers',
  financeTestiQuote: "La solution Alpha Solutions nous a permis d'automatiser entièrement notre gestion de portefeuille client. Le reporting automatisé conforme aux normes nous fait gagner des semaines de travail chaque mois.",
  financeSatisfied: 'Client satisfait depuis 2021',
  financeCtaTitle: 'Prêt à Moderniser Vos Services Financiers ?',
  financeCtaDesc: 'Rejoignez les institutions financières qui nous font confiance',
  financeAdv1Title: 'Conformité Garantie',
  financeAdv1Desc: '100% de conformité aux réglementations financières',
  financeAdv2Title: 'Efficacité +50%',
  financeAdv2Desc: "Amélioration de l'efficacité opérationnelle",
  financeAdv3Title: 'Réduction Risques',
  financeAdv3Desc: 'Diminution de 60% des risques opérationnels',
  financeAdv4Title: 'ROI Optimisé',
  financeAdv4Desc: 'Amélioration du retour sur investissement',

  // Satisfied since label
  satisfiedSince: 'Client satisfait depuis',

  // Immobilier sector
  immobilierHeroTitle: 'Solutions Immobilier',
  immobilierHeroDesc: 'Gérez efficacement votre patrimoine immobilier avec nos outils de gestion locative et de suivi des biens',
  immobilierSolutionsTitle: 'Nos Solutions Immobilier',
  immobilierSolutionsSubtitle: 'Une plateforme complète pour optimiser la gestion de votre patrimoine immobilier',
  immobilierWhyTitle: 'Pourquoi Choisir Nos Solutions ?',
  immobilierTestiName: 'SCI Platinum',
  immobilierTestiRole: 'Gestion Immobilière',
  immobilierTestiQuote: "La solution Alpha Solutions a transformé notre gestion immobilière. Le suivi automatisé des locataires et la facturation en ligne nous ont fait gagner un temps précieux. Notre taux de recouvrement a augmenté de 40% en 6 mois.",
  immobilierTestiSince: 'Client satisfait depuis 2021',
  immobilierCtaTitle: 'Prêt à Optimiser Votre Gestion Immobilière ?',
  immobilierCtaDesc: 'Rejoignez les gestionnaires immobiliers qui nous font confiance',
  immobilierAdv1Title: 'Gain de Temps',
  immobilierAdv1Desc: 'Automatisation de 80% des tâches administratives récurrentes',
  immobilierAdv2Title: 'Réduction des Impayés',
  immobilierAdv2Desc: 'Diminution de 60% des retards de paiement grâce aux alertes',
  immobilierAdv3Title: 'Satisfaction Locataires',
  immobilierAdv3Desc: 'Amélioration de la relation locataire avec le portail dédié',
  immobilierAdv4Title: 'Optimisation Rentabilité',
  immobilierAdv4Desc: 'Augmentation moyenne de 15% de la rentabilité immobilière',
  immobilierSol1Title: 'Gestion de Portefeuille Immobilier',
  immobilierSol1Desc: 'Centralisation de tous vos biens immobiliers avec suivi détaillé',
  immobilierSol2Title: 'Gestion Locataires & Contrats',
  immobilierSol2Desc: 'Suivi complet des locataires et gestion automatisée des contrats',
  immobilierSol3Title: 'Facturation & Comptabilité',
  immobilierSol3Desc: 'Automatisation de la facturation et suivi financier',
  immobilierSol4Title: 'Maintenance & Travaux',
  immobilierSol4Desc: 'Planification et suivi des interventions de maintenance',
  immobilierSol5Title: 'Portail Locataires',
  immobilierSol5Desc: 'Interface dédiée pour vos locataires',
  immobilierSol6Title: 'Analyses & Reporting',
  immobilierSol6Desc: 'Tableaux de bord pour optimiser votre rentabilité',

  // Production sector
  productionHeroTitle: 'Solutions Production & Industrie',
  productionHeroDesc: 'Optimisez votre production industrielle avec nos solutions de planification, qualité et maintenance',
  productionSolutionsTitle: 'Nos Solutions Production & Industrie',
  productionSolutionsSubtitle: 'Une suite complète pour optimiser votre chaîne de production industrielle',
  productionWhyTitle: 'Pourquoi Choisir Nos Solutions ?',
  productionTestiName: 'SOFIPAC',
  productionTestiRole: 'Production & Industrie',
  productionTestiQuote: "Avec Alpha Solutions, notre planification de production est devenue entièrement automatisée. Le contrôle qualité intégré nous a permis de réduire nos défauts de 80% et d'augmenter notre productivité de 30%.",
  productionTestiSince: 'Client satisfait depuis 2020',
  productionCtaTitle: 'Prêt à Optimiser Votre Production ?',
  productionCtaDesc: 'Rejoignez les industriels qui nous font confiance pour leur transformation digitale',
  productionAdv1Title: 'Productivité +25%',
  productionAdv1Desc: "Augmentation moyenne de la productivité grâce à l'optimisation",
  productionAdv2Title: 'Réduction Coûts',
  productionAdv2Desc: 'Diminution de 20% des coûts de production et maintenance',
  productionAdv3Title: 'Qualité Améliorée',
  productionAdv3Desc: 'Réduction de 70% des défauts grâce au contrôle qualité',
  productionAdv4Title: 'Traçabilité Totale',
  productionAdv4Desc: 'Suivi complet de la chaîne de production',
  productionSol1Title: 'Planification de Production',
  productionSol1Desc: 'Optimisation des plannings de production avec gestion des ressources',
  productionSol2Title: 'Gestion Qualité',
  productionSol2Desc: 'Contrôle qualité intégré avec traçabilité complète',
  productionSol3Title: 'Maintenance Préventive',
  productionSol3Desc: 'Planification et suivi de la maintenance des équipements',
  productionSol4Title: 'Gestion des Stocks',
  productionSol4Desc: 'Inventaire matières premières et produits finis',
  productionSol5Title: 'Coûts de Production',
  productionSol5Desc: 'Calcul précis des coûts et analyse de rentabilité',
  productionSol6Title: 'Tableaux de Bord',
  productionSol6Desc: 'Indicateurs de performance en temps réel',

  // Administration sector
  administrationHeroTitle: 'Solutions Administration Publique',
  administrationHeroDesc: 'Modernisez vos services publics avec nos solutions de gestion citoyenne et dématérialisation',
  administrationSolutionsTitle: 'Nos Solutions Administration Publique',
  administrationSolutionsSubtitle: 'Une plateforme complète pour la modernisation des services publics',
  administrationWhyTitle: 'Pourquoi Choisir Nos Solutions ?',
  administrationTestiName: 'Port Autonome de Douala',
  administrationTestiRole: 'Administration Publique',
  administrationTestiQuote: "La digitalisation de nos services portuaires avec Alpha Solutions a transformé notre efficacité. La gestion documentaire optimisée et les services en ligne ont considérablement amélioré notre relation avec les usagers.",
  administrationTestiSince: 'Client satisfait depuis 2019',
  administrationCtaTitle: 'Prêt à Moderniser Vos Services Publics ?',
  administrationCtaDesc: 'Rejoignez les administrations qui nous font confiance',
  administrationAdv1Title: 'Transparence',
  administrationAdv1Desc: 'Amélioration de la transparence des services publics',
  administrationAdv2Title: 'Efficacité +40%',
  administrationAdv2Desc: "Amélioration de l'efficacité des services administratifs",
  administrationAdv3Title: 'Satisfaction Citoyenne',
  administrationAdv3Desc: 'Amélioration de la satisfaction des usagers',
  administrationAdv4Title: 'Économies',
  administrationAdv4Desc: 'Réduction des coûts administratifs de 30%',
  administrationSol1Title: 'Gestion des Citoyens',
  administrationSol1Desc: 'Base de données centralisée des citoyens et services',
  administrationSol2Title: 'Gestion Documentaire',
  administrationSol2Desc: 'Dématérialisation et archivage des documents officiels',
  administrationSol3Title: 'Services en Ligne',
  administrationSol3Desc: 'Portail de services publics numériques',
  administrationSol4Title: 'Gestion Financière Publique',
  administrationSol4Desc: 'Comptabilité et budget public',
  administrationSol5Title: 'Ressources Humaines Publiques',
  administrationSol5Desc: 'Gestion du personnel de la fonction publique',
  administrationSol6Title: 'Tableaux de Bord Publics',
  administrationSol6Desc: 'Indicateurs de performance des services publics',

  // Prestataire Service sector
  prestataireHeroTitle: 'Solutions Prestataires de Service',
  prestataireHeroDesc: 'Gérez vos interventions, contrats et équipes avec une plateforme tout-en-un dédiée aux prestataires de service',
  prestataireSolutionsTitle: 'Nos Solutions pour Prestataires de Service',
  prestataireSolutionsSubtitle: 'Une suite complète pour optimiser vos opérations et satisfaire vos clients',
  prestataireCtaTitle: 'Prêt à Digitaliser Votre Activité de Service ?',
  prestataireCtaDesc: 'Rejoignez les prestataires qui optimisent leurs opérations avec Alpha Solutions',
  prestataireSol1Title: 'Gestion des Interventions',
  prestataireSol1Desc: 'Planification et suivi des interventions terrain',
  prestataireSol2Title: 'CRM Prestataires',
  prestataireSol2Desc: 'Gestion des clients et contrats de service',
  prestataireSol3Title: 'Facturation & Devis',
  prestataireSol3Desc: 'Génération rapide de devis et factures',
  prestataireSol4Title: 'Gestion des Équipes',
  prestataireSol4Desc: 'Planification RH et gestion des agents',
  prestataireSol5Title: 'Stock & Matériel',
  prestataireSol5Desc: 'Gestion du matériel et des consommables',
  prestataireSol6Title: 'Tableau de Bord Service',
  prestataireSol6Desc: 'Pilotage global de votre activité de service',

  // BTP Construction sector
  btpHeroTitle: 'Solutions BTP & Construction',
  btpHeroDesc: 'Pilotez vos chantiers, gérez vos équipes et contrôlez vos coûts avec nos solutions dédiées au BTP',
  btpSolutionsTitle: 'Nos Solutions BTP & Construction',
  btpSolutionsSubtitle: 'Une plateforme complète pour maîtriser chaque aspect de vos projets de construction',
  btpCtaTitle: 'Maîtrisez Chaque Chantier avec Précision',
  btpCtaDesc: 'Rejoignez les entreprises BTP qui digitalisent leurs opérations avec Alpha Solutions',
  btpSol1Title: 'Gestion de Chantier',
  btpSol1Desc: 'Suivi complet de vos chantiers de construction',
  btpSol2Title: 'Gestion des Approvisionnements',
  btpSol2Desc: 'Contrôle des matériaux et achats',
  btpSol3Title: 'Devis & Facturation BTP',
  btpSol3Desc: 'Estimation précise et facturation automatisée',
  btpSol4Title: 'Gestion RH Chantier',
  btpSol4Desc: 'Gestion des ouvriers et pointage',
  btpSol5Title: 'Matériel & Équipements',
  btpSol5Desc: 'Gestion du parc matériel et maintenance',
  btpSol6Title: 'Reporting & Finance BTP',
  btpSol6Desc: 'Contrôle financier et pilotage BTP',

  // RH Placement sector
  rhHeroTitle: 'Solutions RH & Placement',
  rhHeroDesc: 'Gérez vos candidats, placements et contrats RH avec une plateforme conçue pour les agences de recrutement et cabinets RH',
  rhSolutionsTitle: 'Nos Solutions RH & Placement',
  rhSolutionsSubtitle: 'Automatisez votre processus de recrutement et de placement pour gagner en efficacité',
  rhCtaTitle: 'Boostez Votre Activité de Placement RH',
  rhCtaDesc: 'Rejoignez les agences RH qui font confiance à Alpha Solutions',
  rhSol1Title: 'Gestion des Candidatures',
  rhSol1Desc: 'Traitement des CV et suivi des candidats',
  rhSol2Title: 'Placements & Missions',
  rhSol2Desc: 'Gestion des missions de travail temporaire',
  rhSol3Title: 'Gestion des Contrats RH',
  rhSol3Desc: 'Contrats de travail et paie externalisée',
  rhSol4Title: 'Portail Client Entreprises',
  rhSol4Desc: 'Interface dédiée pour vos entreprises clientes',
  rhSol5Title: 'Formation & Compétences',
  rhSol5Desc: 'Gestion des formations et montée en compétences',
  rhSol6Title: 'Reporting RH',
  rhSol6Desc: 'Analyses et statistiques de votre activité RH',

  // Cabinets Conseil sector
  cabinetsHeroTitle: 'Solutions Cabinets & Conseil',
  cabinetsHeroDesc: "Gérez vos missions, consultants et clients avec une plateforme conçue pour les cabinets de conseil et d'audit",
  cabinetsSolutionsTitle: 'Nos Solutions pour Cabinets & Conseil',
  cabinetsSolutionsSubtitle: 'Optimisez la gestion de votre cabinet et améliorez la rentabilité de vos missions',
  cabinetsCtaTitle: 'Élevez la Performance de Votre Cabinet',
  cabinetsCtaDesc: 'Rejoignez les cabinets de conseil qui modernisent leur gestion avec Alpha Solutions',
  cabinetsSol1Title: 'Gestion des Missions',
  cabinetsSol1Desc: 'Suivi des missions et projets de conseil',
  cabinetsSol2Title: 'CRM & Développement Commercial',
  cabinetsSol2Desc: 'Acquisition et fidélisation de clients',
  cabinetsSol3Title: 'Facturation au Temps',
  cabinetsSol3Desc: 'Facturation basée sur le temps passé',
  cabinetsSol4Title: 'Gestion Documentaire Cabinet',
  cabinetsSol4Desc: 'Centralisation des documents et rapports',
  cabinetsSol5Title: 'Gestion des Consultants',
  cabinetsSol5Desc: 'Planification et allocation des ressources',
  cabinetsSol6Title: 'Tableau de Bord Direction',
  cabinetsSol6Desc: 'Pilotage stratégique du cabinet',

  // Video Surveillance sector
  videoHeroTitle: 'Vidéosurveillance & Sécurité',
  videoHeroDesc: "Protégez vos locaux, contrôlez les accès et supervisez à distance avec nos solutions de sécurité intelligentes",
  videoSolutionsTitle: 'Nos Solutions de Sécurité & Surveillance',
  videoSolutionsSubtitle: 'Des systèmes robustes et intelligents pour une protection totale de vos actifs',
  videoCtaTitle: 'Sécurisez Votre Entreprise Dès Maintenant',
  videoCtaDesc: "Audit de sécurité gratuit — nos experts évaluent vos besoins et vous proposent une solution adaptée",
  videoCtaBtn: 'Audit Gratuit',
  videoSol1Title: 'Vidéosurveillance IP',
  videoSol1Desc: 'Systèmes de caméras intelligentes haute résolution',
  videoSol2Title: "Contrôle d'Accès",
  videoSol2Desc: 'Gestion intelligente des accès et entrées',
  videoSol3Title: 'Biométrie & Pointage',
  videoSol3Desc: 'Système de pointage biométrique fiable',
  videoSol4Title: 'Enregistrement & Stockage',
  videoSol4Desc: 'Archivage sécurisé des images et vidéos',
  videoSol5Title: 'Supervision à Distance',
  videoSol5Desc: 'Monitoring centralisé multi-sites',
  videoSol6Title: 'Interphonie & Barrières',
  videoSol6Desc: "Contrôle d'accès physique et interphonie",

  // Atelier Garage sector
  atelierHeroTitle: 'Solutions Atelier & Garage',
  atelierHeroDesc: 'Gérez vos ordres de réparation, stocks de pièces et planning atelier avec une solution dédiée aux garages et centres auto',
  atelierSolutionsTitle: 'Nos Solutions Atelier & Garage',
  atelierSolutionsSubtitle: "Tout ce dont votre garage a besoin pour optimiser son activité et satisfaire vos clients",
  atelierCtaTitle: "Modernisez Votre Atelier Dès Aujourd'hui",
  atelierCtaDesc: 'Des dizaines de garages font confiance à Alpha Solutions pour leur gestion quotidienne',
  atelierSol1Title: 'Ordres de Réparation',
  atelierSol1Desc: 'Gestion complète des interventions mécaniques',
  atelierSol2Title: 'Gestion des Pièces',
  atelierSol2Desc: 'Stock de pièces détachées et consommables',
  atelierSol3Title: 'Gestion des Véhicules Clients',
  atelierSol3Desc: 'Historique complet par véhicule',
  atelierSol4Title: 'Facturation & Caisse',
  atelierSol4Desc: 'Encaissement et facturation atelier',
  atelierSol5Title: 'Planning Atelier',
  atelierSol5Desc: 'Organisation des créneaux et mécaniciens',
  atelierSol6Title: 'Tableaux de Bord Garage',
  atelierSol6Desc: 'Pilotage de la performance de votre garage',

  // Bulk SMS sector
  bulkSmsHeroTitle: 'Bulk SMS & WhatsApp Business',
  bulkSmsHeroDesc: 'Atteignez instantanément vos clients avec des campagnes SMS et WhatsApp massives — marketing, OTP, alertes et automatisation',
  bulkSmsSolutionsTitle: 'Nos Solutions Bulk SMS & WhatsApp',
  bulkSmsSolutionsSubtitle: 'Une plateforme complète pour toutes vos communications digitales en masse',
  bulkSmsCtaTitle: "Lancez Votre Première Campagne Aujourd'hui",
  bulkSmsCtaDesc: 'Essai gratuit — testez la plateforme avec 100 SMS offerts sans engagement',
  bulkSmsCtaBtn: 'Démarrer Gratuitement',
  bulkSmsFreeTrial: 'Essai Gratuit',
  bulkSmsStat1Label: 'Taux de livraison SMS',
  bulkSmsStat2Label: "Délai d'envoi moyen",
  bulkSmsStat3Label: 'SMS envoyés/mois',
  bulkSmsStat4Label: 'Disponibilité plateforme',
  bulkSmsSol1Title: 'Bulk SMS',
  bulkSmsSol1Desc: 'Envoi massif de SMS à vos contacts',
  bulkSmsSol2Title: 'WhatsApp Business API',
  bulkSmsSol2Desc: 'Campagnes WhatsApp professionnelles',
  bulkSmsSol3Title: 'Chatbot WhatsApp',
  bulkSmsSol3Desc: 'Automatisation des réponses WhatsApp',
  bulkSmsSol4Title: 'SMS OTP & Sécurité',
  bulkSmsSol4Desc: "Codes d'authentification et vérification",
  bulkSmsSol5Title: 'Marketing Automatisé',
  bulkSmsSol5Desc: 'Campagnes marketing et fidélisation',
  bulkSmsSol6Title: 'Rapports & Analytics',
  bulkSmsSol6Desc: 'Analyse des performances de vos campagnes',
}
